import { TabPanel, TabView } from 'primereact/tabview';
import { Panel } from 'primereact/panel';

import {CommonDialog} from '../../common/CommonDialog';
import { Form } from '../../common/Form';
import { useEffect, useState } from 'react';
import CmsService from '../../../service/CmsService';
import { jwordFontList, jwordFontSizeList } from '../../cms/editor/jword-config';
import { ProcViewer } from '../../common/ProcViewer';
import ScrService from '../../../service/ScrService';
import { LETTERS } from '../const';

export function PrintDialog({testId,test,visible,items,mode,onOK,onCancel})
{
    //mode: none,pdf,odt
    const [ps,setPs] = useState({booklets:['A'],replacePrev:true,qnoPattern:'1.',qnoFont:'Arial',qnoStyle:1,qnoFontSize:12,
        optNoPattern:'a.',optNoFont:'Arial',optNoStyle:1,optNoFontSize:11,questionProps:'NONE',separation:0,
        optNoIndent:8,qnoIndent:14,qnoHanging:true,scaleImages:true
    });
    const [temps,setTemps] = useState([]);
    const [proc,setProc] = useState(null);

    const [bookletOptions,setBookletOptions]=useState([]);
    const qnoPatternOptions = [
        {label:'1.',value:'1.'},
        {label:'1)',value:'1)'},
        {label:'(1)',value:'(1)'},
        {label:'[1]',value:'[1]'},
        {label:'1-',value:'1-'},
        {label:'1:',value:'1:'},
        {label:'1',value:'1'},
        {label:'Q 1',value:'Q 1'},
        {label:'Q-1',value:'Q-1'},
        {label:'Item 1',value:'Item 1'}
    ];
    const optNoPatternOptions = [
        {label:'A.',value:'A.'},
        {label:'A)',value:'A)'},
        {label:'(A)',value:'(A)'},
        {label:'[A]',value:'[A]'},
        {label:'A-',value:'A-'},
        {label:'A',value:'A'},
        {label:'a.',value:'a.'},
        {label:'a)',value:'a)'},
        {label:'(a)',value:'(a)'},
        {label:'[a]',value:'[a]'},
        {label:'a-',value:'a-'},
        {label:'a',value:'a'}, 
    ];
    const styleOptions = [
        {label:'Normal',value:0},
        {label:'Bold',value:1},
        {label:'Italic',value:2},
        {label:'Bold-Italic',value:3}, 
    ];
    const questionPropsOptions = [
        {label:'None',value:'NONE'},
        {label:'Simple',value:'SIMPLE'},
        {label:'Advanced',value:'ADVANCED'}
    ];

    const onChange=(form)=>{
        setPs(form);
    }
    const onProcOK=(proc)=>{
        console.log("proc ended:"+JSON.stringify(proc));
        var datId = parseInt(proc.fileName);
        if(mode=='pdf')
        {            
            CmsService.downloadDocAsPdf(datId).then((resp)=>{
                var blobObj = new Blob([resp.data], { type: "application/pdf" })
                const fileURL = window.URL.createObjectURL(blobObj);
                let alink = document.createElement("a");
                alink.href = fileURL;
                alink.target = '_blank';
                //alink.download = "booklet.pdf";
                alink.click();     
                onOK(proc.id);           
            });            
        }
        else if(mode=='odt')
        {
            CmsService.downloadDat(datId).then((resp)=>{
                    var blobObj = new Blob([resp.data], { type: "application/vnd.oasis.opendocument.text" })
                    const fileURL = window.URL.createObjectURL(blobObj);
                    let alink = document.createElement("a");
                    alink.href = fileURL;
                    alink.download = "booklet.odt";
                    alink.click();                
                onOK(proc.id);           
            });
        }
        else
            onOK(proc.id);
    }
    const genDoc=(_items)=>{
        CmsService.generateDocs(test,ps,_items).then((ret)=>{
            setProc(ret);
        })    
    }
    const _onOK=()=>{
        if(testId>0)
        {
            ScrService.getBookletItems(testId).then((_items)=>{
                genDoc(_items);
            });
        }
        else
        {
            var itms=items.map((id)=>{return {qid:id}});
            var sects=[{id:0,ord:1,code:'',name:'sect1',items:itms}];
            var docs={'A':sects};
            genDoc(docs);
        }
    }
    const _onCancel=()=>{
        onCancel();
    }
    const _setBookletOptions=(bookletCount)=>{
        var opts=[];
        for(var i=0;i<bookletCount;i++)
            opts.push(LETTERS.substring(i,i+1));
        setBookletOptions(opts);
    }
    useEffect(()=>{
        _setBookletOptions(test.booklets);
    },[test]);
    useEffect(()=>{
        CmsService.getTemps().then((ret)=>{
            setTemps(ret);
        })
    },[])
    return(
        <>
        <CommonDialog header={'Test document generation'} visible={visible} onOK={_onOK} onCancel={_onCancel}>
            <div style={{width:'450px',height:'350px'}}>
            <ProcViewer service={CmsService} procId={proc!=undefined?proc.id:-1} onOK={onProcOK}></ProcViewer>
            <TabView hidden={proc!=undefined && proc.id>0}>
                <TabPanel header="Format">
                    <Form id="printFormat" formData={ps} columns="1" onChange={onChange} fields={[
                        {id:"tempId",ftype:"dropdown",field:"tempId",label:"Template",options:temps,optionLabel:"name",optionValue:'id'},
                        {id:"booklets",ftype:"multiSelect",field:"booklets",label:"Booklets",options:bookletOptions,hidden:(testId==0)},
                        {id:"questionProps",ftype:"dropdown",field:"questionProps",label:"Question info",options:questionPropsOptions},
                        {id:"solution",ftype:"checkbox",field:"solution",label:"Add solution"},
                        {id:"replacePrev",ftype:"checkbox",field:"replacePrev",label:"Replace previous archive",hidden:(testId==0)}                        
                    ]}/>
                </TabPanel>
                <TabPanel header="Question numbers">
                    <Form id="qnoFormat" formData={ps} columns="2" onChange={onChange} fields={[
                            {id:"qnoPattern",ftype:"dropdown",field:"qnoPattern",label:"Pattern",options:qnoPatternOptions,optionLabel:'label',optionValue:'value'},
                            {id:"qnoFont",ftype:"dropdown",field:"qnoFont",label:"Font face",options:jwordFontList,optionLabel:'family',optionValue:'family'},
                            {id:"qnoFontSize",ftype:"dropdown",field:"qnoFontSize",label:"Font size",options:jwordFontSizeList},
                            {id:"qnoStyle",ftype:"dropdown",field:"qnoStyle",label:"Style",options:styleOptions,optionLabel:'label',optionValue:'value'},
                            {id:"qnoIndent",ftype:"number",field:"qnoIndent",label:"Indent"}]}/>
                    <Form id="qnoFormat2" formData={ps} columns="1" onChange={onChange} fields={[
                            {id:"qnoHanging",ftype:"checkbox",field:"qnoHanging",label:"Hanging"},
                            {id:"qnoBreak",ftype:"checkbox",field:"qnoBreak",label:"Put line break after question number"},
                            {id:"qnoUnderline",ftype:"checkbox",field:"qnoUnderline",label:"Underline whole line"}
                        ]}/>
                </TabPanel>
                <TabPanel header="Option numbers">
                    <Form id="optFormat" formData={ps} columns="2" onChange={onChange} fields={[
                            {id:"optNoPattern",ftype:"dropdown",field:"optNoPattern",label:"Pattern",options:optNoPatternOptions,optionLabel:'label',optionValue:'value'},
                            {id:"optNoFont",ftype:"dropdown",field:"optNoFont",label:"Font face",options:jwordFontList,optionLabel:'family',optionValue:'family'},
                            {id:"optNoFontSize",ftype:"dropdown",field:"optNoFontSize",label:"Font size",options:jwordFontSizeList},
                            {id:"optNoStyle",ftype:"dropdown",field:"optNoStyle",label:"Style",options:styleOptions,optionLabel:'label',optionValue:'value'},
                            {id:"optNoIndent",ftype:"number",field:"optNoIndent",label:"Indent"}
                        ]}/>
                </TabPanel>
                <TabPanel header="Extra Settings">
                <Form id="extra" formData={ps} columns="1" onChange={onChange} fields={[
                            {id:"separation",ftype:"number",field:"separation",label:"Separation"},
                            {id:"minOptHeight",ftype:"number",field:"minOptHeight",label:"Minimum height of option rows"},
                            {id:"scaleImages",ftype:"checkbox",field:"scaleImages",label:"Scale images when needed"},
                            {id:"centerOptsAlone",ftype:"checkbox",field:"centerOptsAlone",label:"Center options at last row"}
                        ]}/>
                </TabPanel>
            </TabView>
            </div>
        </CommonDialog>
        </>
    )
}